import { render, staticRenderFns } from "./AddResellerPage.vue?vue&type=template&id=f958a450"
import script from "./AddResellerPage.vue?vue&type=script&lang=js"
export * from "./AddResellerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports